import React, { useState, useContext } from 'react';
import { fetchCurriculumEquivalences } from '../../../services/equivalence_curriculum_service';
import Button from 'components/common/buttons/Button';
import withCards, { CardContext } from 'hoc/withCards';
import CurricularEquivalenceList from './CurricularEquivalenceList';
import { useHistory } from 'react-router';
import CurricularEquivalenceFilter from './CurricularEquivalenceFilter';
import ListFilterButton from 'components/common/buttons/ListFilterButton';

const CurricularEquivalenceListPage = ({ ...props }) => {
  const [complementaryActivities, setComplementaryActivities] = useState();
  const [openFilter, setOpenFilter] = useState(false);
  const history = useHistory();
  return (
    <>
      <div className="align-buttons">
        <Button onClick={() => history.push('/equivalencias/curricular/new')}>
          Cadastrar Equivalência Curricular
        </Button>
      </div>
      <CurricularEquivalenceFilter
        filters={props.onChangeForm}
        open={openFilter}
      />
      <CurricularEquivalenceList {...props} />
    </>
  );
};

export default withCards({
  fetch: fetchCurriculumEquivalences,
  title: 'Equivalências Curriculares',
  paginated: true,
  noResultsText: 'Nenhuma Equivalência foi encontrada.',
  checkFirstFormChange: false,
})(CurricularEquivalenceListPage);
